export default __webpack_public_path__ + "static/media/AskMeLogoAltOptimized.082876df.webp";